<app-pre-loader *ngIf="loadingBar !== undefined && +(loadingBar.progress$|async) > 0"></app-pre-loader>
<app-topbar *ngIf="show()"></app-topbar>
<app-sidepanels *ngIf="show()"></app-sidepanels>
<div [ngClass]="isContentPage ? ' ' : 'default-height'">
    <ng-content></ng-content>
</div>

<!-- Floating RTP widget (ported from template-02). Shown on qp2a–qp2d, logged-in players only. -->
<div *ngIf="isQP2 && rtpDomain && showRtp && isLoggedIn()" class="rtp-img" [class.rtp-img-above-chat]="liveChatExists">
    <img src="/assets/rtp/rtp-floating-icon-animated.gif" class="rtp-icon-img" (click)="onRTP()">
    <span class="rtp-close-btn" (click)="onCloseRTP($event)">×</span>
</div>

